module.exports = __webpack_public_path__ + "img/cards-ellipsis.7be6bbfe.png";